export default __webpack_public_path__ + "static/media/avatar_dragon2.aed4531d.mp3";